<div class="grid-row grid-gap-1">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <legend class="usa-legend usa-legend--medium">Global Update Rates</legend>
  </div>
</div>
<form [formGroup]="frtRateGlobalUpdateFormGroup">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label class="usa-label" for="rate_type">Rate Type</label>
      <select id="rate_type" class="maxw-full usa-select" formControlName="rateTypeId" (change)="onRateTypeChange($event)">
        <option value='' selected disabled>Choose...</option>
        <option [value]="18">Freight - TL</option>
        <option [value]="19">Freight - LTL</option>
        <option [value]='20'>Fleet Vehicles - Domestic 1</option>
        <option [value]='21'>Fleet Vehicles - Domestic 2</option>
        <option [value]='22'>Fleet Vehicles - Domestic 3</option>
        <option [value]='23'>Fleet Vehicles - International 1</option>
        <option [value]='24'>Fleet Vehicles - International 2</option>
        <option [value]='25'>Fleet Vehicles - International 3</option>
      </select>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label class="usa-label" for="agency_id">SRO ID</label>
      <select id="agency_id" class="maxw-full usa-select" formControlName="sroMasterId" (change)="onSroTypeChange($event)">
        <option value='' selected disabled>Choose...</option>
        @for (sro of ratesSroIdList; track sro) {
          <option [value]="sro.sroMasterId">{{sro.sroId}}
          </option>
        }
      </select>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label class="usa-label" for="origin">Origin</label>
      <select id="origin" class="maxw-full usa-select" formControlName="originId" (change)="onOriginChange($event)">
        <option value='' selected disabled>Choose...</option>
        @for (origin of sroOriginStateCountries; track origin) {
          <option [value]="origin.stateCountryId">
            {{origin.stateCountryName}}
          </option>
        }
      </select>
      @if (showRecords) {
        <span class="text-base-dark">{{recordsCount}} Records Available for Update</span>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label class="usa-label" for="tender_id">Tender ID</label>
      <input type="text" placeholder="Enter Your Tender ID" id="tender_id" class="maxw-full usa-input" formControlName="tenderId" oninput="this.value = this.value.toUpperCase()" [minLength]="4" [maxLength]="4">
      @if (this.frtRateGlobalUpdateFormGroup.get('tenderId').invalid && (this.frtRateGlobalUpdateFormGroup.get('tenderId').touched
        || this.frtRateGlobalUpdateFormGroup.get('tenderId').dirty)) {
        <div>
          <small class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/img/sprite.svg#add"></use>
            </svg> Tender ID must be 4 characters
          </small>
        </div>
      }
      @if ((this.frtRateGlobalUpdateFormGroup.get('tenderId').touched
        && this.frtRateGlobalUpdateFormGroup.get('tenderId').hasError('pattern'))) {
        <div>
          <small class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/img/sprite.svg#add"></use>
            </svg> Invalid characters in Tender ID
          </small>
        </div>
      }
    </div>
    @if (showTl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="tl_min_charge_change">TL Min. Charge</label>
        <select id="tl_min_charge_change" formControlName="tlMinChargeChangeType" class="maxw-full usa-select">
          <option value='' selected disabled>Choose...</option>
          @for (change of tlChangeType; track change) {
            <option [value]="change">{{change}}</option>
          }
        </select>
      </div>
    }
    @if (showTl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="tl_min_charge">TL Min. Value</label>
        <input type="text" id="tl_min_charge" class="maxw-full usa-input" formControlName="tlMinimumCharge" [maxlength]="9" appTwoDigitDecimalNumber>
        @if (this.frtRateGlobalUpdateFormGroup.get('tlMinimumCharge').hasError('pattern') && (this.frtRateGlobalUpdateFormGroup.get('tlMinimumCharge').touched ||
          this.frtRateGlobalUpdateFormGroup.get('tlMinimumCharge').dirty)) {
          <div>
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/img/sprite.svg#add"></use>
              </svg> Please enter only decimal values or integers.
            </small>
          </div>
        }
      </div>
    }
    @if (showTl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="tl_rate_amount_change">TL Rate Amount</label>
        <select id="tl_rate_amount_change" formControlName="tlRateAmountChangeType" class="maxw-full usa-select">
          <option value='' selected disabled>Choose...</option>
          @for (change of tlChangeType; track change) {
            <option [value]="change">{{change}}</option>
          }
        </select>
      </div>
    }
    @if (showTl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="tl_rate_amount">TL Rate Value</label>
        <input type="text" id="tl_rate_amount" class="maxw-full usa-input" formControlName="tlRateAmount" [maxlength]="9" appTwoDigitDecimalNumber>
        @if (this.frtRateGlobalUpdateFormGroup.get('tlRateAmount').hasError('pattern') && (this.frtRateGlobalUpdateFormGroup.get('tlRateAmount').touched
          || this.frtRateGlobalUpdateFormGroup.get('tlRateAmount').dirty)) {
          <div>
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/img/sprite.svg#add"></use>
              </svg> Please enter only decimal values or integers.
            </small>
          </div>
        }
      </div>
    }
    @if (showLtl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="ltl_min_charge_change">Min. Charge %</label>
        <select id="ltl_min_charge_change" formControlName="ltlMinChargeChangeType" class="maxw-full usa-select">
          <option value='' selected disabled>Choose...</option>
          @for (change of ltlChangeType; track change) {
            <option [value]="change">{{change}}</option>
          }
        </select>
      </div>
    }
    @if (showLtl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="ltl_min_charge">Min. Charge % Value</label>
        <input type="text" id="ltl_min_charge" class="maxw-full usa-input" formControlName="ltlMinimumChargePct" appNumbersOnly [maxlength]="4">
      </div>
    }
    @if (showLtl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="ltl_surcharge_pct_change">LTL % </label>
        <select id="ltl_surcharge_pct_change" formControlName="ltlSurchargePctChangeType" class="maxw-full usa-select">
          <option value='' selected disabled>Choose...</option>
          @for (change of ltlChangeType; track change) {
            <option [value]="change">{{change}}</option>
          }
        </select>
      </div>
    }
    @if (showLtl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="ltl_surcharge_pct" class="usa-label">LTL % Value</label>
        <input type="text" id="ltl_surcharge_pct" class="maxw-full usa-input" formControlName="ltlSurchargePct" appNumbersOnly [maxlength]="4">
      </div>
    }
    @if (showVehcl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="vehcle_rate_amount_change">Vehicle Rate Amount</label>
        <select id="vehcle_rate_amount_change" formControlName="vehcleRateAmountChangeType" class="maxw-full usa-select">
          <option value='' selected disabled>Choose...</option>
          @for (change of vehcleChangeType; track change) {
            <option [value]="change">{{change}}</option>
          }
        </select>
      </div>
    }
    @if (showVehcl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="vehcle_rate_amount">Rate Value</label>
        <input type="text" id="vehcle_rate_amount" class="usa-input maxw-full" formControlName="vehcleRateAmount" [maxlength]="9" appTwoDigitDecimalNumber>
        @if (this.frtRateGlobalUpdateFormGroup.get('vehcleRateAmount').hasError('pattern') && (this.frtRateGlobalUpdateFormGroup.get('vehcleRateAmount').touched
          || this.frtRateGlobalUpdateFormGroup.get('vehcleRateAmount').dirty)) {
          <div>
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/img/sprite.svg#add"></use>
              </svg> Please enter only decimal values or integers.
            </small>
          </div>
        }
      </div>
    }

    @if (showAccl) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <legend class="usa-legend usa-legend--medium">Accessorial Service Codes</legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <button type="button" class="usa-button" (click)="addAccessorials()" [disabled]="!this.frtRateGlobalUpdateFormGroup || this.frtRateGlobalUpdateFormGroup.get('sroMasterId').invalid">Add</button>
          </div>
        </div>
      </div>
    }

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      @for (objs of frtRateGlobalUpdateFormGroup.get('accessorials')['controls']; track objs; let i = $index) {
        <div formArrayName="accessorials">
          <ng-container [formGroupName]="i">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <select id="accessorial" formControlName="frtAccessorialMasterId" class="maxw-full usa-select">
                  <option value='' selected disabled>Choose...</option>
                  @for (accessorial of frtAccessorials; track accessorial) {
                    <option
                      [value]="accessorial.frtAccessorialsMasterEntity.frtAccessorialsId">
                      {{ accessorial?.frtAccessorialsMasterEntity?.accessorialCode }} - {{
                      accessorial?.frtAccessorialsMasterEntity?.accessorialDescription }}
                    </option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <select id="accessorialType" formControlName="accessorialChangeType" class="maxw-full usa-select">
                  <option value='' selected disabled>Choose...</option>
                  @for (change of tlChangeType; track change) {
                    <option>{{change}}</option>
                  }
                </select>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <div class="grid-row flex-row">
                  <div class="grid-col">
                    <input type="text" class="maxw-full usa-input" placeholder="Rate Amount" formControlName="accessorialAmount" [maxlength]="15" appTwoDigitDecimalNumber>
                    @if (this.frtRateGlobalUpdateFormGroup.get('accessorials').controls[i].get('accessorialAmount').hasError('pattern')) {
                      <div class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/img/sprite.svg#add"></use>
                        </svg> Please enter only decimal values or integers.
                      </div>
                    }
                  </div>
                  <div class="grid-col">
                    <input type="text" class="usa-input maxw-full" placeholder="Minimum Charge" formControlName="minimumAmount" [maxlength]="10" appTwoDigitDecimalNumber>
                    @if (this.frtRateGlobalUpdateFormGroup.get('accessorials').controls[i].get('minimumAmount').hasError('pattern')) {
                      <div class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/img/sprite.svg#add"></use>
                        </svg> Please enter only decimal values or integers.
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3 display-flex flex-row">
                <div class="flex-align-self-end">
                  <button type="button" class="usa-button usa-button--secondary" (click)="deleteAccessorials(i)">Delete</button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
      <button type="button" class="usa-button" (click)="save()" [disabled]="!this.frtRateGlobalUpdateFormGroup || this.frtRateGlobalUpdateFormGroup.invalid">Update</button>
    </div>
  </div>
</form>
